import { DatePicker, Input } from 'antd'
import moment from 'moment'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { SearchDrawerComponent } from '../../../../../components'
import { translate } from '../../../../../languages'
import { RootState } from '../../../../../stores'
import { setWorkScheduleFilter } from '../../../../../stores/actions'

const StyledRow = styled.div`
  margin-bottom: 10px;
  display: flex;
`

const StyledLabel = styled.span`
  border: 1px solid #d9d9d9;
  border-right: none;
  padding: 3px 10px;
  background-color: #fafafa;
  display: inline-flex;
`

export const SearchWorkScheduleDrawerComponent: React.FC = () => {
  const dispatch = useDispatch()
  const { language } = useSelector((state: RootState) => state.language)
  const { workScheduleFilter } = useSelector(
    (state: RootState) => state.workSchedule
  )
  const [filter, setFilter] = React.useState(workScheduleFilter)

  const body = (
    <>
      <StyledRow>
        <Input
          placeholder={translate('workSchedule.employee', language)}
          addonBefore={translate('workSchedule.employee', language)}
          value={filter.employeeName}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              employeeName: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <Input
          placeholder={translate('workSchedule.station', language)}
          addonBefore={translate('workSchedule.station', language)}
          value={filter.stationName}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              stationName: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <Input
          placeholder={translate('workSchedule.shift', language)}
          addonBefore={translate('workSchedule.shift', language)}
          value={filter.stationName}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              stationName: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <StyledLabel>{translate(`workSchedule.time`, language)}:</StyledLabel>
        <DatePicker.RangePicker
          picker="time"
          style={{ width: '100%' }}
          format="HH:mm"
          value={[
            moment(filter.startTime, 'HH:mm'),
            moment(filter.endTime, 'HH:mm'),
          ]}
          allowClear={false}
          inputReadOnly
          onChange={(_, dateString) =>
            setFilter({
              ...filter,
              startTime:
                dateString && dateString.length === 2 ? dateString[0] : '00:00',
              endTime:
                dateString && dateString.length === 2 ? dateString[1] : '23:59',
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <StyledLabel>{translate(`workSchedule.date`, language)}:</StyledLabel>
        <DatePicker.RangePicker
          picker="date"
          style={{ width: '100%' }}
          format="DD-MM-YYYY"
          value={[moment(filter.startDate), moment(filter.endDate)]}
          allowClear={false}
          onChange={(e) =>
            setFilter({
              ...filter,
              startDate:
                e && e.length === 2 && e[0] ? e[0]?.toDate().getTime() : 0,
              endDate:
                e && e.length === 2 && e[1]
                  ? e[1]?.toDate().getTime()
                  : undefined,
            })
          }
        />
      </StyledRow>
    </>
  )

  return (
    <SearchDrawerComponent
      body={body}
      onSearch={() => dispatch(setWorkScheduleFilter(filter))}
    />
  )
}
